import * as React from 'react';
import { IStoreSelectorButtonViewProps } from './store-selector-button';

export default (props: IStoreSelectorButtonViewProps) => {
    const {
        data: {
            storeSelectorStateManager: { result: storeSelectorStateManager }
        },
        modules,
        slots,
        telemetry,
        resources
    } = props;

    const handleClick = React.useCallback(() => {
        if (!storeSelectorStateManager) {
            return;
        }

        let storeSelectorId: string = '';
        if (modules && Object.keys(modules).length > 0 && modules.storeSelector && modules.storeSelector.length > 0) {
            storeSelectorId = modules.storeSelector[0].id;
        }
        storeSelectorStateManager
            .openDialog({
                id: storeSelectorId,
                showMapViewLink: false,
                onLocationSelected: orgUnitLocation => {
                    return Promise.resolve();
                }
            })
            .catch((error: Error) => {
                if (telemetry) {
                    telemetry.error(error.message);
                    telemetry.debug('Unable to set preferred store');
                }
                return;
            });
    }, [storeSelectorStateManager, modules, telemetry]);

    if (!slots?.storeSelector?.length) {
        return null;
    }

    const storeName = storeSelectorStateManager?.preferredStore?.StoreName || resources.headerPreferredStoreText;

    return (
        <div className='store-selector-container'>
            <div className='store-selector-link' role='button' onClick={handleClick}>
                <i className='fonticon-marker' />
                <span className='store-selector-text'>{storeName}</span>
            </div>
            {slots.storeSelector}
        </div>
    );
};
